import { HistoryListProps } from "@husky-x/history-list";

export const HistoryMockFr: HistoryListProps  = {
	data: [
		{
			year: 1915,
			description: 'LA Jackson fonde la London Rubber Company et vend des préservatifs et accessoires importés pour les coiffeurs',
		},
		{
			year: 1929,
			description: 'La London Rubber Company (LRC) dépose la marque Durex',
		},
		{
			year: '1950er',
			description: 'Durex sort son premier préservatif lubrifié',
		},
		{
			year: 1953,
			description: 'Durex est la première marque à développer et à faire des tests électroniques',
		},
		{
			year: '1960er',
			description: 'Durex lance le premier préservatif à forme anatomique',
		},
		{
			year: '1970er',
			description: 'Durex est la première marque de préservatifs au monde à faire de la publicité dans de nombreux pays',
		},
		{
			year: '1990er',
			description: 'Durex est la première marque de préservatifs à adopter un label de qualité mondial comme norme',
		},
		{
			year: 1995,
			description: 'Durex sort une gamme de préservatifs colorés et aromatisés',
		},
		{
			year: 1996,
			description: 'Durex est la première marque de préservatifs à lancer son site internet. Aujourd’hui nous avons 42 sites différents dans les pays où la marque est commercialisée',
		},
		{
			year: 1997,
			description: 'Durex sort des préservatifs sans latex. Une nouvelle matière non allergénique est utilisée pour le nouveau produit : le polyuréthane synthétique. Développé par Durex, il est plus doux et plus élastique que le caoutchouc naturel du latex',
		},
		{
			year: 1998,
			description: 'Durex est la première marque de préservatifs à conduire et publier une étude mondiale sur le bien-être sexuel',
		},
		{
			year: 2001,
			description: 'Durex présente Pleasuremax. Il fait de Durex la première marque à commercialiser un préservatif qui allie une texture perlée et nervurée',
		},
		{
			year: 2003,
			description: 'Durex lance une gamme confort et ludique de lubrifiants Play',
		},
		{
			year: 2005,
			description: 'Le réseau Durex lance ses rapports « Face of Global Sex » qui explorent les aspects des comportements sexuels et qui sont destinés à informer les universitaires et pouvoirs publiques',
		},
		{
			year: 2008,
			description: "Afin de promouvoir le sexe en toute sécurité pour les jeunes, Durex encourage des jeunes âgés de 16 à 24 ans à créer une affiche unique sur la santé sexuelle – un poster d'adolescents pour les adolescents",
		},
		{
			year: 2009,
			description: "Durex a 80 ans!",
		},
		{
			year: 2010,
			description: "Durex soutient l'initiative « Condomize! » du Fonds des Nations unies pour la population au cours de la Conférence internationale AIDS de Vienne en faisant don de 220 000 préservatifs",
		},
		{
			year: 2010,
			description: 'Durex est racheté par Reckitt Benckiser',
		},
		{
			year: 2010,
			description: "Durex lance Performax Intense, un préservatif conçu pour atteindre l'orgasme simultanément. Avec 5 % de benzocaïne dans le revêtement intérieur et une structure stimulante, il aide à prolonger et intensifier les relations sexuelles",
		},
		{
			year: 2018,
			description: 'Partenariat avec l’association RED',
		},
		{
			year: 2019,
			description: 'Durex a 90 ans!',
		},
		{
			year: 2020,
			description: 'Lancement en pharmacie et grandes surfaces d’une gamme de préservatifs et lubrifiants Perfect Gliss positionnée sur le sexe anal',
		},
		{
			year: 2020,
			description: 'Clarification des boîtes de préservatifs Durex en ajoutant une codification visuelle permettant d’orienter le consommateur d’une manière claire vers le préservatif qui lui correspond le mieux : taille, largeur nominale, lubrification et matière',
		},
	]
}